import { Component } from 'react';

/**
 * FRONTEIRA DE ERRO — uma area que quebra nao derruba mais o site inteiro.
 *
 * O PROBLEMA (18/10/2026): a Auditoria renderizava `old_value`/`new_value` do
 * historico de migracoes como filho do React. A unificacao de cadastros
 * duplicados grava um OBJETO nesse campo, e o React lanca
 * "Objects are not valid as a React child". Sem nenhuma fronteira de erro, a
 * arvore INTEIRA era desmontada: a pagina ficava TODA PRETA (o `body` e
 * #0A0A0A), sem menu e sem mensagem. O mesmo valia para o dialogo
 * "Historico de migracoes" da tela de Atletas.
 *
 * A CORRECAO tem duas camadas:
 *  1. o valor passou a ser convertido para texto (AuditPage + dialogo);
 *  2. esta fronteira, que isola QUALQUER erro de renderizacao de uma area:
 *     o resto do sistema (menu, cabecalho, outras telas) continua funcionando.
 *
 * Uso: <ErrorBoundary><Outlet /></ErrorBoundary> (area) ou em volta de <Routes>.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { temErro: false };
  }

  static getDerivedStateFromError() {
    return { temErro: true };
  }

  componentDidCatch(erro, info) {
    // Diagnostico no console; nada de detalhe tecnico na tela do usuario.
    console.error('Erro de renderizacao isolado pela fronteira:', erro, info);
  }

  render() {
    if (this.state.temErro) {
      return (
        <div data-testid="erro-fronteira" className="min-h-[50vh] flex items-center justify-center p-6">
          <div className="bg-[#141414] border border-[#27272A] rounded-xl p-8 max-w-md text-center">
            <h2 className="text-lg font-bold text-white mb-2">Esta area nao pode ser exibida</h2>
            <p className="text-sm text-[#A1A1AA] mb-4">
              Ocorreu um erro ao montar esta tela. O restante do sistema continua funcionando.
            </p>
            <button
              type="button"
              onClick={() => this.setState({ temErro: false })}
              className="px-4 py-2 rounded-lg bg-[#D4AF37] text-black font-bold text-sm hover:bg-[#E5C158]"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
